/*
 * Login action
 */

// General - App State related constants
export const SET_AVATAR_OPTIONS = 'SET_AVATAR_OPTIONS'
export const SET_ROOM_CODE = 'SET_ROOM_CODE'
export const SET_USER_NAME = 'SET_USER_NAME'
export const START_SOCIAL_LOGIN = 'START_SOCIAL_LOGIN'
export const START_AVATAR_SELECTION = 'START_AVATAR_SELECTION'
export const ROOM_NOT_FOUND_ERROR = 'ROOM_NOT_FOUND_ERROR'
export const RESET_BIOS_INPUT = 'RESET_BIOS_INPUT'

export const LoginVersions = {
    CODE: 'CODE',
    REGULAR: 'REGULAR',
    USERNAME: 'USERNAME'
}

export const LoginStates = {
    BIOS: 'BIOS', // Add bios Code
    AVATAR: 'AVATAR', // Select Avatar
    SOCIAL_LOGIN: 'SOCIAL_LOGIN', // Select social login type
    
    CODE_LOGIN: 'CODE_LOGIN',
    USERNAME: 'USERNAME'
}


/*
 * Login state setters 
 */
export function setRoomCode(roomCode) {
    return { type: SET_ROOM_CODE, roomCode: roomCode}
}

export function setUserName(name) {
    return { type: SET_USER_NAME, name: name}
}

export function setAvatarOptions(avatars) {
    return { type: SET_AVATAR_OPTIONS, avatars: avatars}
}

export function startSocialLogin() {
    return { type: START_SOCIAL_LOGIN }
}

export function startAvatarSelection() {
    return { type: START_AVATAR_SELECTION }
}

export function roomNotFoundError() {
    return { type: ROOM_NOT_FOUND_ERROR }
}

export function resetBiosInput() {
    return { type: RESET_BIOS_INPUT }
}


// WEBPACK FOOTER //
// ./src/components/store/actions/login.js